export default function check() {
  return 'app';
}
